import * as React from 'react';

/**
 * Признак редизайна быстрых фильтров.
 *
 * Ветвление по группе эксперимента делает `<ExpSearchStringAndFastFilters>` в панели фильтров —
 * один раз и с отправкой экспозиции. Чипсы лежат глубоко внутри, поэтому признак им отдаётся
 * обычным контекстом: и пропсы через полдерева тащить не надо, и экспозиция не дублируется
 * на каждый чипс.
 */
export const FiltersRedesignContext = React.createContext(false);

export function useIsFiltersRedesign(): boolean {
  return React.useContext(FiltersRedesignContext);
}
